import React, { useState } from 'react';
import CircularGallery from './CircularGallery';

export default function VisualDesignPortfolio({ onBack }) {
  const [activeImage, setActiveImage] = useState(null);

  // 已经为你批量处理好的 21 张作品数据
  const designProjects = [
    { id: 1, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/2000x2000.webp", text: "产品渲染（c4d oc）" },
    { id: 2, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/b.webp", text: "场景渲染（C4D SP OC）" },
    { id: 3, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/OUT_%E5%8D%95%E8%BE%B9.webp", text: "产品渲染（c4d oc）" },
    { id: 4, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/out-%E9%95%80%E8%86%9C.webp", text: "产品渲染（c4d oc）" },
    { id: 5, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E4%B8%BB%E9%A2%98%E8%A7%84%E5%88%99.jpg", text: "主题规则排版(C4D lovart PS)" },
    { id: 6, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E5%B0%BE%E5%9B%BE-out.webp", text: "产品渲染（c4d oc）" },
    { id: 7, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E6%89%8B%E6%9C%BA%E5%A3%B3.webp", text: "产品渲染（c4d oc）" },
    { id: 8, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E7%8E%AB%E7%BA%A2%E5%B9%B3%E5%85%89-out.webp", text: "产品渲染（c4d oc）" },
    { id: 9, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E7%B4%AB%E8%89%B2-out.webp", text: "产品渲染（c4d oc）图" },
    { id: 10, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E7%B4%AB%E8%89%B2.webp", text: "产品渲染（c4d oc）" },
    { id: 11, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E7%B4%AB%E8%89%B2%E5%B9%B3%E5%85%89-%E9%A6%96%E5%9B%BE.webp", text: "产品渲染（c4d oc）" },
    { id: 12, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E7%B4%AB%E8%89%B2%E9%95%80%E8%86%9C.webp", text: "产品渲染（c4d oc）" },
    { id: 13, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E8%8B%B1%E5%BC%8F.webp", text: "产品渲染（c4d oc）" },
    { id: 14, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E8%92%82%E6%B4%9B%E8%96%872.webp", text: "产品渲染（c4d oc）" },
    { id: 15, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E8%92%82%E6%B4%9B%E8%96%87.webp", text: "产品渲染（c4d oc）" },
    { id: 16, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E8%8B%B1%E5%BC%8F2.webp", text: "产品渲染（c4d oc）" },
    { id: 17, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E9%94%AE%E7%9B%98.webp", text: "产品渲染（c4d oc）" },
    { id: 18, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E9%A3%9E%E7%A7%91.webp", text: "产品渲染（c4d xp oc）" },
    { id: 19, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E9%BA%A6%E5%85%8B%E7%91%9E.webp", text: "产品渲染（c4d oc）" },
    { id: 20, image: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/images/%E9%BA%A6%E5%85%8B%E7%91%9E2.webp", text: "产品渲染（c4d oc）" }
  ];

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-10 px-6 md:px-12 pb-24 overflow-hidden relative animate-[fadeIn_0.8s_ease-out]">
      
      {/* 返回按钮 */}
      <button 
        onClick={onBack}
        className="fixed top-8 left-8 z-50 flex items-center gap-2 text-neutral-400 hover:text-white transition-colors duration-300 group backdrop-blur-md bg-black/40 px-4 py-2 rounded-full border border-white/10"
      >
        <svg className="w-5 h-5 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
        <span className="font-mono text-sm tracking-widest uppercase">Back</span>
      </button>

      {/* 标题区 */}
      <div className="max-w-[1600px] mx-auto mt-20 mb-8 space-y-4 text-center md:text-left pl-0 md:pl-8 border-l-0 md:border-l-4 border-fuchsia-600 relative z-30">
        <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-fuchsia-500 tracking-tighter uppercase">
          视觉设计
        </h1>
        <p className="text-neutral-500 font-mono tracking-[0.3em] uppercase text-xs">
          Cinema 4D // octane // substance painter // X-Particles // ps // lovart ai
        </p>
      </div>

      {/* 在 VisualDesignPortfolio.js 里的位置 */}
{/* 🚀 将高度改为 h-[calc(100vh-250px)]，确保它可以上下滚动查看 21 张图 */}
<div className="w-full h-[calc(100vh-250px)] relative z-20 mt-10">
  <CircularGallery 
    items={designProjects} 
    onItemClick={(item) => setActiveImage(item)} 
  />
</div>

      {/* 全屏放大灯箱 */}
      {activeImage && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 backdrop-blur-2xl animate-[fadeIn_0.3s_ease-out]"
          onClick={() => setActiveImage(null)} 
        >
          <button className="absolute top-8 right-8 p-4 text-white/40 hover:text-white transition-colors duration-300"><svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" /></svg></button>
          <div className="relative max-w-[90vw] max-h-[85vh] rounded-2xl overflow-hidden shadow-2xl border border-white/5" onClick={(e) => e.stopPropagation()}>
            <img src={activeImage.image} alt={activeImage.text} className="max-w-full max-h-[85vh] object-contain" />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 p-8 pt-20"><h2 className="text-2xl font-bold text-white/90">{activeImage.text}</h2></div>
          </div>
        </div>
      )}
    </div>
  );
}